import React from 'react'
import styled from '@emotion/styled'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { RxWebSocketStatus } from 'messaging'
import { connectionStoreSelector } from 'selectors/storeSelectors'
import { ConnectionStatus, CredentialsStatus } from 'store/connection'
import { StatusPanel } from './StatusPanel'
import { LoginBackground } from './LoginBackground'
import { AuthCredentialsRetrieval } from './AuthCredentialsRetrieval'
import { diagnosticsLogger } from 'logger/diagnosticsLogger'

export interface AuthContentProps {
  isMainWindow: boolean
  credentialsStatus: CredentialsStatus
  socketStatus: RxWebSocketStatus[]
  connectionStatus: ConnectionStatus
  children?: React.ReactNode
}

const mapStateToProps = createSelector(connectionStoreSelector, connectionStore => {
  return {
    credentialsStatus: connectionStore.credentialsStatus,
    socketStatus: connectionStore.socketStatus,
    connectionStatus: connectionStore.connectionStatus
  }
})

const mapDispatchToProps = {}

const AuthContentWrapper = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export class AuthContentComponent extends React.Component<AuthContentProps> {
  render() {
    return <AuthContentWrapper>{this.getContent()}</AuthContentWrapper>
  }

  private getContent() {
    const { children, credentialsStatus, connectionStatus, socketStatus, isMainWindow } = this.props

    if (connectionStatus === ConnectionStatus.LoggedIn) {
      return children
    } else if (credentialsStatus === CredentialsStatus.NotSet) {
      diagnosticsLogger.log('ConnectionStatus not logged in and credentialsStatus is not set. Rendering LoginBackground.')
      if (isMainWindow) {
        return (
          <LoginBackground>
            <AuthCredentialsRetrieval />
          </LoginBackground>
        )
      } else {
        return (
          <LoginBackground>
            <StatusPanel statuses={socketStatus} />
          </LoginBackground>
        )
      }
    } else if (credentialsStatus === CredentialsStatus.Available) {
      diagnosticsLogger.log('ConnectionStatus not logged in but credentialsStatus available. Rendering LoginBackground.')
      return (
        <LoginBackground>
          <StatusPanel statuses={socketStatus} />
        </LoginBackground>
      )
    } else {
      throw new Error(`Unexpected CredentialsStatus ${credentialsStatus}`)
    }
  }
}

export const AuthContent = connect(mapStateToProps, mapDispatchToProps)(AuthContentComponent)
